export const mapCabinetTypeToSubdomain = {
  dsp: "dsp-partner",
  advert: "advert",
  exchange: "exchange",
  webmaster: "webmaster"
};

export const mapSubdomainToCabinetType = Object.keys(
  mapCabinetTypeToSubdomain
).reduce(
  (prev, next) => {
    const subdomain = mapCabinetTypeToSubdomain[next];

    return {
      ...prev,
      [subdomain]: next
    };
  },
  {
    dsp: "dsp"
  }
);
